import { ArrowDownward, ArrowUpward, LinearScale } from "@mui/icons-material";

export type TendencyType = "increase" | "neutral" | "decrease";

export const getTendencyType = (tendency: number): TendencyType => {
  if (tendency > 0) return "increase";
  if (tendency < 0) return "decrease";
  return "neutral";
};

const getTendencyIcon = (type: TendencyType) => {
  switch (type) {
    case "increase":
      return <ArrowUpward />;
    case "neutral":
      return <LinearScale />;
    case "decrease":
      return <ArrowDownward />;
  }
};

export const TENDENCY_COLORS = {
  increase: "success",
  neutral: "info",
  decrease: "error",
} as const;

export const TENDENCY_LABELS = {
  increase: "Creciente",
  neutral: "Neutral",
  decrease: "Decreciente",
} as const;

export const getTendencyInfo = (tendency: number) => {
  const type = getTendencyType(tendency);
  return {
    type,
    color: TENDENCY_COLORS[type],
    label: TENDENCY_LABELS[type],
    icon: getTendencyIcon(type),
  };
};
